import { render, staticRenderFns } from "./ownArchives.vue?vue&type=template&id=ef671020&scoped=true&"
import script from "./ownArchives.vue?vue&type=script&lang=js&"
export * from "./ownArchives.vue?vue&type=script&lang=js&"
import style0 from "./ownArchives.vue?vue&type=style&index=0&id=ef671020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef671020",
  null
  
)

export default component.exports